import React, { useEffect, useState, JSX } from 'react';

import { ApiFilterOption } from '@ibe/api';

import { clone } from '@ibe/services';
import FilterOption from './FilterOption';

export type FilterOverrides = {
  filterRange?: {
    steps?: number;
    roundMinMax?: number;
  };
};

export interface Props {
  options: ApiFilterOption[];
  selected?: ApiFilterOption[];
  onChange?: (selected: ApiFilterOption[]) => void;
  showResultsCountInParenthesis?: boolean;
  showResultsCount?: boolean;
  singleSelectCategories?: boolean;
  showEmptyOptionsWhenFiltering?: boolean;
}

const FilterOptions = (props: Props): JSX.Element => {
  const {
    onChange,
    options,
    selected,
    showResultsCountInParenthesis,
    showEmptyOptionsWhenFiltering,
    singleSelectCategories,
    showResultsCount
  } = props;

  const option = options || [];
  const change = onChange || null;

  const [select, setSelected] = useState<ApiFilterOption[]>(selected || []);
  useEffect((): void => setSelected(selected || []), [selected]);

  const add = (o: ApiFilterOption): void => {
    if (!select.includes(o)) {
      const sel = singleSelectCategories ? [] : (clone(select) as ApiFilterOption[]);
      sel.push(o);
      setSelected(sel);
      if (change) {
        change(sel);
      }
    }
  };

  const remove = (o: ApiFilterOption): void => {
    if (select.findIndex(op => op.id === o.id) !== -1) {
      const sel = (clone(select) as ApiFilterOption[]).filter(
        (s: ApiFilterOption) => s.id !== o.id
      );
      setSelected(sel);
      if (change) {
        change(sel);
      }
    }
  };

  return (
    <>
      {Object.values(option).map(
        (o: ApiFilterOption): JSX.Element => {
          const active = select.find(s => s.id === o.id);
          if (!o.label) {
            return <></>;
          }

          return (
            <FilterOption
              id={o.id}
              key={o.id}
              isActive={!!active}
              onChange={(isActive): void => (isActive ? add(o) : remove(o))}
              label={o.label}
              resultsCount={o.results}
              showEmptyOptionsWhenFiltering={showEmptyOptionsWhenFiltering}
              showResultsCountInParenthesis={showResultsCountInParenthesis}
              showResultsCount={showResultsCount}
            />
          );
        }
      )}
    </>
  );
};

export default FilterOptions;
